import React, { useState, useEffect } from "react";
import { Button, Select, Spin, message } from "antd";
import { createVendorGender, createVendorGenderAlias, getAllVendorGenders, updateException } from "../api";
import { ExceptionStatus } from "../ExceptionDrawer";
import Hide from "../../components/Hide";

const { Option } = Select;

const VendorGenderComponent = ({ exception, onClose, onResolved }) => {
    const [vendorGenderName, setVendorGenderName] = useState(null);
    const [showSelect, setShowSelect] = useState(false);
    const [vendorGenders, setVendorGenders] = useState([]);
    const [selectedAliasId, setSelectedAliasId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const extractVendorGenderDetails = () => {
            setVendorGenderName(exception?.unknown_infomation);
        };

        if (exception && exception.description) {
            extractVendorGenderDetails();
        }

        const fetchVendorGenders = async () => {
            setLoading(true);
            try {
                const response = await getAllVendorGenders();
                const gendersData = response?.data?.data || [];
                setVendorGenders(Array.isArray(gendersData) ? gendersData : []);
            } catch (error) {
                message.error('Failed to fetch vendor genders');
            } finally {
                setLoading(false);
            }
        };

        fetchVendorGenders();
    }, [exception]);

    const handleMarkAsNew = async () => {
        setLoading(true);
        if (vendorGenderName) {
            if (exception.status === 'pending') {
                try {
                    const payload = {
                        name: vendorGenderName,
                        alias_for: 0
                    };
                    
                    await createVendorGender(payload);
                    await updateException(exception.id);
                    message.success('Vendor gender created');
                    try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                    onClose();
                } catch (error) {
                    message.error('Failed to create vendor gender');
                } finally {
                    setLoading(false);
                }
            } else {
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            }
        } else {
            setLoading(false);
            onClose();
        }
    };

    const handleMarkAsAliasFor = () => {
        setShowSelect(true);
    };

    const handleVendorGenderSelect = (value) => {
        setSelectedAliasId(value ?? null);
    };

    const handleSaveAlias = async () => {
        if (!selectedAliasId) return;
        setLoading(true);
        if (exception.status === 'pending') {
            try {
                const payload = {
                    name: vendorGenderName,
                    alias_for: selectedAliasId
                };
                
                await createVendorGenderAlias(payload);
                await updateException(exception.id);
                message.success('Alias saved');
                try { if (typeof onResolved === 'function') await onResolved(); } catch {}
                onClose();
            } catch (error) {
                message.error('Failed to save alias');
            } finally {
                setLoading(false);
            }
        } else {
            try { if (typeof onResolved === 'function') await onResolved(); } catch {}
            onClose();
        }
    };

    return (
        <div style={{ marginTop: 20 }}>
            <Hide condition={exception.status === ExceptionStatus.RESOLVED}>
                <Spin spinning={loading} tip="Processing...">
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
                        <Button 
                            type="primary" 
                            onClick={handleMarkAsNew}
                            disabled={loading}
                            loading={loading}
                        >
                            Mark as New
                        </Button>
                        <Button 
                            type="default" 
                            onClick={handleMarkAsAliasFor}
                            disabled={loading}
                        >
                            Mark as Alias For
                        </Button>
                        {showSelect && (
                            <>
                                <div style={{ fontSize: 12, color: '#666' }}>
                                    {vendorGenderName ? `Select an existing vendor gender to alias "${vendorGenderName}" to.` : 'Select an existing vendor gender to alias.'}
                                </div>
                                <Select
                                    style={{ minWidth: 220 }}
                                    placeholder="Select a vendor gender"
                                    onChange={handleVendorGenderSelect}
                                    disabled={loading}
                                    value={selectedAliasId ?? undefined}
                                >
                                    {vendorGenders.map((gender) => (
                                        <Option key={gender.id} value={gender.id}>
                                            {gender.name}
                                        </Option>
                                    ))}
                                </Select>
                                <Button
                                    type="primary"
                                    onClick={handleSaveAlias}
                                    disabled={loading || !selectedAliasId}
                                    loading={loading}
                                >
                                    Save
                                </Button>
                            </>
                        )}
                    </div>
                </Spin>
            </Hide>
        </div>
    );
};

export default VendorGenderComponent;
